const defaultLocaleExpertise = 'language-en-ca';

const localesExpertise: Record<string, string> = {
    'fr-ca': 'language-fr-ca',
    'en-ca': 'language-en-ca',
};

const localeToExpertise = (locale: string): string => {
    const localeKey = locale.toLowerCase();
    return localesExpertise[localeKey] || defaultLocaleExpertise;
};

export default localeToExpertise;
